import { IPeople, IResort } from '../types';
import t from '../locales';

export function validateSnowItemFunc({ itemId, people, payableDateList, resort, timeSchedule }: {
  itemId: number,
  payableDateList: Date[],
  people: IPeople,
  resort?: IResort,
  timeSchedule?: string,
}): () => boolean {
  return () => {
    const { adultNum, childNum, studentNum, seniorNum } = people;
    const { stockIntegration } = resort;
    if (itemId == null) {
      alert(t.itemIdIsRequired());
      return false;
    }
    if ((adultNum + childNum + studentNum + seniorNum === 0) || payableDateList.length === 0) {
      alert(t.pleaseSelectNumberOfPeopleAndDateOfUse());
      return false;
    }
    if (stockIntegration != null && (timeSchedule == null || timeSchedule === '')){
      alert(t.chooseATime());
      return false;
    }
    return true;
  };
}

/*
export function validateSnowItem({ itemId, people, payableDateList }: {
  itemId: number,
  payableDateList: Date[],
  people: IPeople,
}): boolean {
  return validateSnowItemFunc({ itemId, people, payableDateList })();
}
*/

export function validateSnowItemNoDateFunc({ itemId, people, numberOfVouchers }: {
  itemId: number,
  people: IPeople,
  numberOfVouchers: number,
}): () => boolean {
  return () => {
    const { adultNum, childNum, studentNum, seniorNum } = people;
    if (itemId == null) {
      alert(t.itemIdIsRequired());
      return false;
    }
    if ((adultNum + childNum + studentNum + seniorNum === 0) || numberOfVouchers === 0) {
      alert(t.pleaseSelectQuantity());
      return false;
    }
    return true;
  };
}

/*
export function validateSnowItemNoDate({ itemId, people, numberOfVouchers }: {
  itemId: number,
  people: IPeople,
  numberOfVouchers: number,
}): boolean {
  return validateSnowItemNoDateFunc({ itemId, people, numberOfVouchers })();
}
*/

export function validateInsuranceOrderRequiredFields({ itemId, people, selectedDateList }: {
  itemId: string,
  people: IPeople,
  selectedDateList: Date[],
}): boolean {
  const { adultNum, childNum, studentNum, seniorNum } = people;
  if (itemId == null) {
    alert(t.itemIdIsRequired());
    return false;
  }
  if ((adultNum + childNum + studentNum + seniorNum === 0) || selectedDateList.length === 0) {
    alert(t.pleaseSelectNumberOfPeopleAndDateOfUse());
    return false;
  }
  return true;
}

export function validateTicketOrderRequiredFields({ itemId, people, selectedDateList, pickupPlace }: {
  itemId: number,
  people: IPeople,
  selectedDateList: Date[],
  pickupPlace?: number,
}): boolean {
  const { adultNum, childNum, studentNum, seniorNum } = people;
  if (itemId == null) {
    alert(t.itemIdIsRequired());
    return false;
  }
  if ((adultNum + childNum + studentNum + seniorNum === 0) || selectedDateList.length === 0) {
    alert(t.pleaseSelectNumberOfPeopleAndDateOfUse());
    return false;
  }
  if (pickupPlace != null && pickupPlace === 0) {
    alert(t.pleaseSelectPickupPlace());
    return false;
  }
  return true;
}
